import React, {FC} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import {H3, H6, Body} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"

interface Props {
  onCTAClick: () => void
}

const EarnPointsModalContent: FC<Props> = ({onCTAClick}) => {
  return (
    <>
      <H3 marginTop={3} marginBottom={2}>
        <FormattedMessage id="platform.earnPoints.modal.heroTitle" />
      </H3>
      <Body>
        <FormattedMessage id="platform.earnPoints.modal.heroBody" />
      </Body>
      <Hr marginTop={2} marginBottom={2} />
      <H6>
        <FormattedMessage id="platform.earnPoints.modal.infoTitle" />
      </H6>
      <Body marginTop={1} marginBottom={6}>
        <FormattedMessage id="platform.earnPoints.modal.infoBody" />
      </Body>
      <Button id="gotItButtonEarnModal" primary full large onClick={onCTAClick}>
        <FormattedMessage id="platform.wallet.TreatTokensModal.button.gotIt" />
      </Button>
    </>
  )
}

export default EarnPointsModalContent
